var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRightS = function SvgArrowRightS(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.587 11H5a1 1 0 0 0 0 2h11.587l-4.658 4.659a1 1 0 0 0 1.414 1.414l6.364-6.364a.996.996 0 0 0 .285-.833.996.996 0 0 0-.285-.585l-6.364-6.364a1 1 0 1 0-1.414 1.414L16.587 11Z",
    clipRule: "evenodd"
  })));
};
export { SvgArrowRightS as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSI+CjxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTYuNTg3IDExSDVhMSAxIDAgMCAwIDAgMmgxMS41ODdsLTQuNjU4IDQuNjU5YTEgMSAwIDAgMCAxLjQxNCAxLjQxNGw2LjM2NC02LjM2NGEuOTk2Ljk5NiAwIDAgMCAuMjg1LS44MzMuOTk2Ljk5NiAwIDAgMC0uMjg1LS41ODVsLTYuMzY0LTYuMzY0YTEgMSAwIDEgMC0xLjQxNCAxLjQxNEwxNi41ODcgMTFaIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz4KPC9zdmc+";